import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useLanguage } from "@/i18n/LanguageContext";
import { verifyRegistration } from "./api";

export function VerifyPage() {
  const { t } = useLanguage();
  const { code = "" } = useParams();
  const [data, setData] = useState<{
    registration_code: string;
    full_name: string;
    conference_name: string;
    status: string;
  } | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    verifyRegistration(code)
      .then((r) => setData(r.data))
      .catch(() => setError(true));
  }, [code]);

  return (
    <div className="dn-card" style={{ maxWidth: 520 }}>
      <h1>{t.verify.title}</h1>
      {error && <div className="dn-alert dn-alert-error">{t.verify.invalid}</div>}
      {data && (
        <>
          <div className="dn-alert dn-alert-ok">{t.verify.valid}</div>
          <p>
            <strong>{data.full_name}</strong>
          </p>
          <p>{data.registration_code}</p>
          <p className="dn-muted">{data.conference_name}</p>
          <p>{data.status}</p>
        </>
      )}
    </div>
  );
}
